import useUser from "@app/zustand/user";
import { isDemoEmail } from "@app/utils/demo-account";

/**
 * Who may curate their own list of displayed fields.
 *
 * Restricted to the demo account and local development while the feature settles: the
 * selection is personal and reversible, but a doctor who hides a field and forgets has no
 * cue left explaining why a card vanished, so real patientèles keep the full view until
 * that affordance exists. The storage layer is already per practitioner — lifting this
 * gate is the only step needed to open it to everyone.
 */
export function useFieldVisibilityEditable(): boolean {
  const user = useUser((state) => state.user);
  const email = (user as { email?: string } | null)?.email;
  return isDemoEmail(email) || import.meta.env.DEV;
}
